import { types } from "../../types/types";

const initialState = {
    cargada: false,
    items: [],
    loading: false,
    error: null,
  };
  
  export const efectoresPReducer = (state = initialState, action) => {
    switch (action.type) {
      case types.efectoresPTraerStart:
        return {
          ...state,
          loading: true,
          error: null,
          cargada: false,
        };
      case types.efectoresPTraerSuccess:
        return {
          ...state,
          loading: false,
          items: action.payload,
          cargada: true,
        };
      case types.efectoresPTraerError:
        return {
          ...state,
          loading: false,
          error: action.payload,
          items: [],
          cargada: false,
        };
      case types.efectoresPLimpiar:
        return {
          loading: false,
          items: [],
          cargada: false,
        };
      case types.efectoresPsetOrDeleteSobreturnos:
        return {
          ...state,
          loading: false,
          items: state.items.map( item => item.idEfectorRed === action.payload.idEfectorP
            ? {...item, configuracionSobreturnos: action.payload.nuevaConfig} 
            : item
          ),
          cargada: true,
        };
      default:
        return state;
    }
  };
  